/**
 * Centralized quiz route URLs.
 * Single source of truth for all quiz navigation paths across the application.
 *
 * Usage:
 * ```tsx
 * import { QUIZ_ROUTES } from "~/constants/quizRoutes";
 *
 * <Link href={QUIZ_ROUTES.HORMONE_IMBALANCE}>Take Quiz</Link>
 * ```
 */
export const QUIZ_ROUTES = {
    HORMONE_IMBALANCE: "/quiz/hormone-imbalance",
    LIBIDA: "/quiz/libida",
    NAD: "/quiz/nad",
    ANTI_AGING_FACE_CREAM: "/quiz/anti-aging-face-cream",
    ENDOMETRIOSIS: "/quiz/endometriosis",
    POSTPARTUM: "/quiz/postpartum",
    OESTRA_CHECK_IN: "/quiz/oestra-check-in",
    BIOIDENTICAL_HRT: "/quiz/bioidentical-hrt",
} as const;

export type QuizRoute = (typeof QUIZ_ROUTES)[keyof typeof QUIZ_ROUTES];
